var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-layout-container"},[_c('div',{staticClass:"content-left"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"auth-layout-header"},[_vm._v(_vm._s(_vm.cardHeader))]),_c('div',{staticClass:"auth-layout-body"},[_vm._t("body")],2)]),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }